import { AuthLayout, DefaultLayout, ChatLayout } from "@/components/layouts"

export const publicRoute = [
  { path: "*", component: () => import(/* webpackChunkName: "errors-404" */ "@/views/error/NotFound.vue") },
  {
    path: "/",
    component: AuthLayout,
    meta: { title: "Login" },
    redirect: "/login",
    hidden: true,
    children: [
      {
        path: "login",
        name: "login",
        meta: { title: "Login" },
        component: () => import(/* webpackChunkName: "login" */ "@/views/auth/Login.vue")
      }
    ]
  },

  {
    path: "/404",
    name: "404",
    meta: { title: "Not Found" },
    component: () => import(/* webpackChunkName: "errors-404" */ "@/views/error/NotFound.vue")
  },

  {
    path: "/500",
    name: "500",
    meta: { title: "Server Error" },
    component: () => import(/* webpackChunkName: "errors-500" */ "@/views/error/Error.vue")
  }
]

export const protectedRoute = [
  {
    path: "/home",
    component: DefaultLayout,
    meta: { title: "Home", group: "apps", icon: "" },
    redirect: "/home/dashboard",
    children: [
      {
        path: "/home/dashboard",
        name: "Dashboard",
        meta: { title: "Home", group: "apps", icon: "dashboard" },
        component: () => import(/* webpackChunkName: "dashboard" */ "@/view/dashboard/DashboardSiRuang.vue")
      },

      {
        path: "/403",
        name: "Forbidden",
        meta: { title: "Access Denied", hiddenInMenu: true },
        component: () => import(/* webpackChunkName: "error-403" */ "@/views/error/Deny.vue")
      }
    ]
  },

  //list
  {
    path: "/cms",
    component: DefaultLayout,
    redirect: "/cms/table",
    meta: { title: "CMS", icon: "view_compact", group: "cms" },
    children: [
      {
        path: "/cms/table",
        name: "ListTable",
        meta: { title: "CMS Table" },
        component: () => import(/* webpackChunkName: "table" */ "@/views/list/Table.vue")
      }
    ]
  },

  //widgets
  {
    path: "/widgets",
    component: DefaultLayout,
    meta: { title: "Widget", icon: "widgets", group: "advance" },
    redirect: "/widgets/chart",
    children: [
      {
        path: "/widgets/chart",
        name: "ChartWidget",
        meta: { title: "Chart Widget" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/views/widgets/Chart.vue")
      },
      {
        path: "/widgets/list",
        name: "ListWidget",
        meta: { title: "List Widget" },
        component: () => import(/* webpackChunkName: "list-widget" */ "@/views/widgets/List.vue")
      },
      {
        path: "/widgets/social",
        name: "SocialWidget",
        meta: { title: "Social Widget" },
        component: () => import(/* webpackChunkName: "social-widget" */ "@/views/widgets/Social.vue")
      },
      {
        path: "/widgets/statistic",
        name: "StatisticWidget",
        meta: { title: "Statistic Widget" },
        component: () => import(/* webpackChunkName: "statistic-widget" */ "@/views/widgets/Statistic.vue")
      }
    ]
  },

  //media
  {
    path: "/media",
    meta: { title: "Media", group: "apps", icon: "media" },
    name: "Media",
    props: route => ({ type: route.query.type }),
    component: () => import(/* webpackChunkName: "routes" */ `@/views/Media.vue`)
  },

  // chat app
  {
    path: "/chat",
    name: "Chat",
    component: ChatLayout,
    redirect: {
      path: "/chat/messaging"
    },
    meta: { title: "Chat", group: "apps", icon: "chat_bubble" },
    children: [
      {
        path: "/chat/messaging/:uuid?",
        name: "ChatMessaging",
        props: true,
        components: () => import(/* webpackChunkName: "chat-messaging" */ `@/components/chat/ChatMessaging.vue`)
      },
      {
        path: "/chat/contact/:uuid?",
        meta: {
          public: true
        },
        name: "ChatContact",
        components: () => import(/* webpackChunkName: "chat-contact" */ `@/components/chat/ChatContact.vue`)
      }
    ]
  },

  //mail app
  {
    path: "/mail",
    meta: {
      public: true
    },
    name: "Mail",
    component: () => import(/* webpackChunkName: "routes" */ `@/components/email/Layout.vue`),
    redirect: {
      path: "/mail/all"
    },
    children: [
      {
        path: "/mail/:mailType",
        meta: {
          public: true
        },
        name: "MailIndex",
        component: () => import(/* webpackChunkName: "routes" */ `@/components/email/List.vue`)
      },
      {
        path: "/mail/0/:uuid",
        meta: {
          public: true
        },
        name: "MailDetail",
        component: () => import(/* webpackChunkName: "routes" */ `@/components/email/Reply.vue`)
      }
    ]
  },

  //ruangan
  {
    path: "/ruangan",
    component: DefaultLayout,
    meta: { title: "Ruangan", icon: "dashboard", group: "app" },
    redirect: "/ruangan/ruangan",
    children: [
      {
        path: "/ruangan/ruangan",
        name: "Daftar Ruangan",
        meta: { title: "Daftar Ruangan" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/ruangan/list.vue")
      },
      {
        path: "/ruangan/add",
        name: "Tambah Ruangan",
        meta: { title: "Tambah Ruangan" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/ruangan/Add.vue")
      },
      {
        path: "/ruangan/edit/:id",
        name: "Ubah Ruangan",
        meta: { title: "Ubah Ruangan" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/ruangan/Edit.vue")
      },
      {
        path: "/ruangan/view/:id",
        name: "Detail Ruangan",
        meta: { title: "Detail Ruangan" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/ruangan/View.vue")
      }
    ]
  },

  //cari ruangan tersedia
  {
    path: "/daftar-ruangan-tersedia",
    component: DefaultLayout,
    meta: { title: "Daftar Ruangan Tersedia",  icon: "dashboard", group: "apps" },
    redirect: "/daftar-ruangan-tersedia/daftar-ruangan-tersedia",
    children: [
      {
        path: "/daftar-ruangan-tersedia/daftar-ruangan-tersedia",
        name: "Daftar Ruangan Tersedia",
        meta: { title: "Daftar Ruangan Tersedia" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/daftarRuanganTersedia/List.vue")
      },
    ]
  },
  
  //Laporan
  {
    path: "/laporan",
    component: DefaultLayout,
    meta: { title: "Laporan",  icon: "file", group: "apps" },
    redirect: "/laporan",
    children: [
      {
        path: "/",
        name: "Laporan",
        meta: { title: "Laporan" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/laporan/Laporan.vue")
      },
    ]
  },

  //peminjaman ruangan
  {
    path: "/peminjaman",
    component: DefaultLayout,
    meta: { title: "Peminjaman", icon: "dashboard", group: "app" },
    redirect: "/peminjaman/peminjaman",
    children: [
      {
        path: "/peminjaman/peminjaman",
        name: "Daftar Peminjaman",
        meta: { title: "Daftar Peminjaman" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/peminjaman/List.vue")
      },
      {
        path: "/peminjaman/add",
        name: "Tambah Peminjaman",
        meta: { title: "Tambah Peminjaman" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/peminjaman/Add.vue")
      },
      {
        path: "/peminjaman/Add2",
        name: "Tambah Peminjaman2",
        meta: { title: "Tambah Peminjaman" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/peminjaman/Add2.vue")
      },
      {
        path: "/peminjaman/add/:id",
        name: "Tambah Peminjaman",
        meta: { title: "Tambah Peminjaman" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/peminjaman/Add.vue")
      },
      {
        path: "/peminjaman/edit/:id",
        name: "Ubah Peminjaman",
        meta: { title: "Ubah Peminjaman" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/peminjaman/Edit.vue")
      },
      {
        path: "/peminjaman/view/:id/:idRuangan",
        name: "Detail Peminjaman",
        meta: { title: "Detail Peminjaman" },
        component: () => import(/* webpackChunkName: "chart-widget" */ "@/view/peminjaman/View.vue")
      }
    ]
  }
]
